import React, { useRef , useState }  from "react";
import { createRoot } from "react-dom/client"; 
import PlayerDropboxNew from './PlayerDropboxNew'
import { useTranslation } from 'react-i18next';




function FilmsNew(){
const { t} = useTranslation();

const containerRef01 = useRef(null);
const containerRef02 = useRef(null);
const containerRef03 = useRef(null);
const containerRef04 = useRef(null);
const containerRef05 = useRef(null); // PAndT
const containerRef06 = useRef(null); // CB
const containerRef07 = useRef(null); // Triumph

const [fadeOutPAndT, setFadeOutPAndT] = useState(false);
const [fadeOutTraffic, setFadeOutTraffic] = useState(false);
const [fadeOutUnder, setFadeOutUnder] = useState(false);
const [fadeOutDuel, setFadeOutDuel] = useState(false);
const [fadeOutBinoc, setFadeOutBinoc] = useState(false);
const [fadeOutCB, setFadeOutCB] = useState(false);
const [fadeOutTriumph, setFadeOutTriumph] = useState(false);

const handleClickTriumph = () => {
    if (containerRef07.current) {
      containerRef07.current.innerHTML = ""; // limpia la imagen
      const root = createRoot(containerRef07.current); // renderiza el video
      root.render(<PlayerDropboxNew  source="https://www.youtube.com/watch?v=Ar_H_GYY6Ec&t=1s"/>);
    }
    setFadeOutTriumph(true);
  };

const handleClickCB = () => {
    if (containerRef06.current) {
      containerRef06.current.innerHTML = ""; // limpia la imagen
      const root = createRoot(containerRef06.current); // renderiza el video
      root.render(<PlayerDropboxNew  source="https://youtu.be/0rx8TUHvn3Y?si=_A9-ZSGrTcwOQhsx"/>);
    }
    setFadeOutCB(true);
  };

const handleClickPAndT = () => {
    if (containerRef05.current) {
      containerRef05.current.innerHTML = ""; // limpia la imagen
      const root = createRoot(containerRef05.current); // renderiza el video
      root.render(<PlayerDropboxNew  source="https://www.dropbox.com/scl/fi/gb30ab7c8h55yz0yj22qi/besties.mp4?rlkey=0w211oy8in3spyk79e33g0g2v&st=7sz9z5pi&dl=0"/>);
    }
    setFadeOutPAndT(true);
  };

const handleClickTraffic = () => {
    if (containerRef01.current) {
      containerRef01.current.innerHTML = ""; // limpia la imagen
      const root = createRoot(containerRef01.current); // renderiza el video
      root.render(<PlayerDropboxNew  source="https://www.dropbox.com/scl/fi/bmhsfbx22w2nco1vmevl4/Traffic-v3.mp4?rlkey=46qjtt4rzemfn3bm5mq0szrjq&dl=0"/>);
    }
    setFadeOutTraffic(true);
  };

const handleClickUnderGrowth = () => {
    if (containerRef02.current) {
      containerRef02.current.innerHTML = ""; // limpia la imagen
      const root = createRoot(containerRef02.current); // renderiza el video
      root.render(<PlayerDropboxNew  source="https://www.dropbox.com/scl/fi/op6e7oo2xsr9h6u2cnur5/Undergrowth.mp4?rlkey=pkz4vt4qmxgaiti72ith1wcvp&st=gopohr3r&dl=0"/>);
    }
    setFadeOutUnder(true);
  };
   
const handleClickDuel = () => {
    if (containerRef03.current) {
      containerRef03.current.innerHTML = ""; // limpia la imagen
      const root = createRoot(containerRef03.current); // renderiza el video
      root.render(<PlayerDropboxNew  source="https://www.dropbox.com/scl/fi/yhteawgyzm8rqr4fn8bwl/The-Duel.mp4?rlkey=lyg9b8tj7cmayrwham1vkxtiq&dl=0"/>);
    }
    setFadeOutDuel(true);
  };

  const handleClickBinoc = () => {
    if (containerRef04.current) {
      containerRef04.current.innerHTML = ""; // limpia la imagen
      const root = createRoot(containerRef04.current); // renderiza el video
      root.render(<PlayerDropboxNew  source="https://www.dropbox.com/scl/fi/zkip10dk1h3t2wvjfj8bj/Film-Audio-Faceoff-Binocular-Trick.mp4?rlkey=fiwl1t28gjhfko2yr6t6cu7nu&st=u6nvn7l9&dl=0"/>);
    }
    setFadeOutBinoc(true);
  };



    return(
      <div className="overlay-content overlay-films" >

                   <div class="row align-items-center mx-3 my-4">       

                      <div class="col-12 col-md-8 d-flex  justify-content-center text-center">
                          <div className = "video-main-container video-film-container" ref={containerRef07}>
                            <img  class="click-to-video"
                                src="./images/TRIUMPH.png"
                                alt="Click para reproducir"
                                style={{ cursor: "pointer", width: "100%" , height: "100%",transition: "opacity 2s ease", opacity: fadeOutTriumph ? 0 : 1,
                                        pointerEvents: fadeOutTriumph ? "none" : "auto", zIndex: 2 }}
                                onClick={handleClickTriumph}   
                            />

                            {/* Flecha/play */}
                            <div className="hover-arrow ">
                              <i className="fas fa-play fa-3x"></i>
                            </div>

                          </div>

                          
                      </div>

                      <div class="col-12 col-md-4">
                        <div className="row align-items-center p-s-4 pe-lg-3  mx-auto">
                            <div className="">
                                <p className=" films-title lead text-start font-face-opensans ">
                                {t('films-title-07')}
                                </p>
                            </div>
                        </div>

                        <div className="row align-items-center  mx-auto">
                            <div className="">
                                <p className="text-start font-face-opensans film-sub">
                                {t('films-subtitle-07')}
                                </p>
                            </div>
                        </div>

                          <div className="row align-items-center p-s-4 pe-lg-3  mx-auto">
                            <div className="">
                                <p className="film-text text-start font-face-opensans ">
                                {t('films-text-07')}
                                </p>
                            </div>
                        </div>
                      </div>


                    </div>


                    <div class="row align-items-center mx-3 my-4">

                      

                      <div class="col-12 col-md-8 d-flex  justify-content-center text-center">
                          <div className = "video-main-container video-film-container" ref={containerRef05}>
                            <img  class="click-to-video"
                                src="./images/PAndT.png"
                                alt="Click para reproducir"
                                style={{ cursor: "pointer", width: "100%" , height: "100%",transition: "opacity 2s ease", opacity: fadeOutPAndT ? 0 : 1,
                                        pointerEvents: fadeOutPAndT ? "none" : "auto", zIndex: 2 }}
                                onClick={handleClickPAndT}   
                            />

                            {/* Flecha/play */}
                            <div className="hover-arrow ">
                              <i className="fas fa-play fa-3x"></i>
                            </div>

                          </div>

                          
                      </div>

                      <div class="col-12 col-md-4">
                        <div className="row align-items-center p-s-4 pe-lg-3  mx-auto">
                            <div className="">
                                <p className=" films-title lead text-start font-face-opensans ">
                                {t('films-title-05')}
                                </p>
                            </div>
                        </div>

                        <div className="row align-items-center  mx-auto">
                            <div className="">
                                <p className="text-start font-face-opensans film-sub">
                                {t('films-subtitle-05')}
                                </p>
                            </div>
                        </div>

                          <div className="row align-items-center p-s-4 pe-lg-3  mx-auto">
                            <div className="">
                                <p className="film-text text-start font-face-opensans ">
                                {t('films-text-05')}
                                </p>
                            </div>
                        </div>
                      </div>


                    </div>


                    <div class="row align-items-center mx-3 my-4">
                      <div class="col-12 col-md-8 d-flex  justify-content-center text-center">
                          <div className = "video-main-container video-film-container" ref={containerRef01}>
                            <img  class="click-to-video"
                                src="./images/trafficNew.png"
                                alt="Click para reproducir"
                                style={{ cursor: "pointer", width: "100%" , height: "100%",transition: "opacity 2s ease", opacity: fadeOutTraffic ? 0 : 1,
                                        pointerEvents: fadeOutTraffic ? "none" : "auto", zIndex: 2 }}
                                onClick={handleClickTraffic}   
                            />

                            {/* Flecha/play */}
                            <div className="hover-arrow ">
                              <i className="fas fa-play fa-3x"></i>
                            </div>

                          </div>

                          
                      </div>

                      <div class="col-12 col-md-4">
                        <div className="row align-items-center p-s-4 pe-lg-3  mx-auto">
                            <div className="">
                                <p className=" films-title lead text-start font-face-opensans ">
                                {t('films-title-01')}
                                </p>
                            </div>
                        </div>

                        <div className="row align-items-center  mx-auto">
                            <div className="">
                                <p className="text-start font-face-opensans film-sub">
                                {t('films-subtitle-01')}
                                </p>
                            </div>
                        </div>

                          <div className="row align-items-center p-s-4 pe-lg-3  mx-auto">
                            <div className="">
                                <p className="film-text text-start font-face-opensans ">
                                {t('films-text-01')}
                                </p>
                            </div>
                        </div>
                      </div>


                    </div>


                    <div class="row align-items-center mx-3 my-4">
                      <div class="col-12 col-md-8 d-flex  justify-content-center text-center">
                          <div className = "video-main-container video-film-container" ref={containerRef02}>
                            <img  class="click-to-video"
                                src="./images/underNew.png"
                                alt="Click para reproducir"
                                style={{ cursor: "pointer", width: "100%" , height: "100%",transition: "opacity 2s ease", opacity: fadeOutUnder ? 0 : 1,
                                        pointerEvents: fadeOutUnder ? "none" : "auto", zIndex: 2 }}
                                onClick={handleClickUnderGrowth}   
                            />

                                                        {/* Flecha/play */}
                            <div className="hover-arrow ">
                              <i className="fas fa-play fa-3x"></i>
                            </div>

                          </div>
                      </div>

                      <div class="col-12 col-md-4">
                        <div className="row align-items-center p-s-4 pe-lg-3  mx-auto">
                            <div className="">
                                <p className=" films-title lead text-start font-face-opensans ">
                                {t('films-title-02')}
                                </p>
                            </div>
                        </div>

                        <div className="row align-items-center p-s-4 pe-lg-3  mx-auto">
                            <div className="">
                                <p className="text-start font-face-opensans ">
                                {t('films-subtitle-02')}
                                </p>
                            </div>
                        </div>

                          <div className="row align-items-center p-s-4 pe-lg-3  mx-auto">
                            <div className="">
                                <p className="film-text text-start font-face-opensans ">
                                {t('films-text-02')}
                                </p>
                            </div>
                        </div>
                      </div>
                    </div>


                    <div class="row align-items-center mx-3 my-4">
                      <div class="col-12 col-md-8 d-flex  justify-content-center text-center">
                          <div className = "video-main-container video-film-container" ref={containerRef03}>
                            <img  class="click-to-video"
                                src="./images/duelNew.png"
                                alt="Click para reproducir"
                                style={{ cursor: "pointer", width: "100%" , height: "100%",transition: "opacity 2s ease", opacity: fadeOutDuel ? 0 : 1,
                                        pointerEvents: fadeOutDuel ? "none" : "auto", zIndex: 2 }}
                                onClick={handleClickDuel}   
                            />

                                                        {/* Flecha/play */}
                            <div className="hover-arrow ">
                              <i className="fas fa-play fa-3x"></i>
                            </div>

                          </div>
                      </div>

                      <div class="col-12 col-md-4">
                        <div className="row align-items-center p-s-4 pe-lg-3  mx-auto">
                            <div className="">
                                <p className=" films-title lead text-start font-face-opensans ">
                                {t('films-title-03')}
                                </p>
                            </div>
                        </div>

                        <div className="row align-items-center p-s-4 pe-lg-3  mx-auto">
                            <div className="">
                                <p className="text-start font-face-opensans ">
                                {t('films-subtitle-03')}
                                </p>
                            </div>
                        </div>

                          <div className="row align-items-center p-s-4 pe-lg-3  mx-auto">
                            <div className="">
                                <p className="film-text  text-start font-face-opensans ">
                                {t('films-text-03')}
                                </p>
                            </div>
                        </div>
                      </div>
                    </div>


                    <div class="row align-items-center mx-3 my-4">
                      <div class="col-12 col-md-8 d-flex  justify-content-center text-center">
                          <div className = "video-main-container video-film-container" ref={containerRef04}>
                            <img  class="click-to-video"
                                src="./images/binoNew.png"
                                alt="Click para reproducir"
                                style={{ cursor: "pointer", width: "100%" , height: "100%",transition: "opacity 2s ease", opacity: fadeOutBinoc ? 0 : 1,
                                        pointerEvents: fadeOutBinoc ? "none" : "auto", zIndex: 2 }}
                                onClick={handleClickBinoc}   
                            />
                                                        {/* Flecha/play */}
                            <div className="hover-arrow ">
                              <i className="fas fa-play fa-3x"></i>
                            </div>

                          </div>
                      </div>

                      <div class="col-12 col-md-4">
                        <div className="row align-items-center p-s-4 pe-lg-3  mx-auto">
                            <div className="">
                                <p className=" films-title lead text-start font-face-opensans ">
                                {t('films-title-04')}
                                </p>
                            </div>
                        </div>

                        <div className="row align-items-center p-s-4 pe-lg-3  mx-auto">
                            <div className="">
                                <p className="text-start font-face-opensans ">
                                {t('films-subtitle-04')}
                                </p>
                            </div>
                        </div>

                          <div className="row align-items-center p-s-4 pe-lg-3  mx-auto">
                            <div className="">
                                <p className="film-text text-start font-face-opensans ">
                                {t('films-text-04-01')}
                                </p>
                            </div>
                        </div>
                          <div className="row align-items-center p-s-4 pe-lg-3  mx-auto">
                            <div className="">
                                <p className="film-text text-start font-face-opensans ">
                                {t('films-text-04-02')}
                                </p>
                            </div>
                        </div>
                          <div className="row align-items-center p-s-4 pe-lg-3  mx-auto">
                            <div className="">
                                <p className="film-text text-start font-face-opensans ">
                                {t('films-text-04-03')}
                                </p>
                            </div>
                          </div>
                      </div>
                    </div>



      </div>
    )
}
export default FilmsNew